module.exports = __webpack_public_path__ + "static/EGO_x2-8b067ccbcc11dfe074fdbdb0f7bb5799.png";